const global = import.meta.glob('./global/**/*.js',{ eager: true, import: 'default' })

const directives = {}
Object.entries(global).forEach(([path, component]) => {
	directives[path.replace('./global/', '').replace('.js', '')] = component
})

export default {
	install(app) {
		Object.keys(directives).forEach((key) => {
			app.directive(key, directives[key])
		});
	}
}
